// extracted by mini-css-extract-plugin
export default {"label":"VendorSubmit_label__dJbmD"};